import { AfterViewInit, Component, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import HighchartsSunburst from 'highcharts/modules/sunburst';

import { Router, ActivatedRoute } from '@angular/router';
declare let $: any;
import * as Aos from 'aos';
import Swal from 'sweetalert2';
import { Buffer } from 'buffer';
// declare let Swiper: any;
// declare let bootstrap: any;
import { fciWebsiteService } from '../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
//FOR LANGUAGE CONVERSION - STARTS (FOR TOGGLING LANGUAGE CONVERSION)
import { TranslateService } from '@ngx-translate/core';
import { CustomServiceService } from '../../service/custom-service.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);
HighchartsSunburst(Highcharts);
@Component({ 
  selector: 'app-labour-strength',
  templateUrl: './labour-strength.component.html',
  styleUrls: ['./labour-strength.component.css']
})
export class LabourStrengthComponent {
  constructor(
    private fciwebservice: fciWebsiteService,
    private httpservice: CustomServiceService,
    private routerparam: ActivatedRoute,
    private route: Router,
    private encDec: EncryptDecryptService,
    public translate: TranslateService
  ) {
    //code
  }
  language:any=sessionStorage.getItem('locale');
  ngOnInit(): void {
    this.start = (this.currentPage - 1) * this.limit;
    this.getQCData('', '', '', this.start, this.limit, this.currentPage);
    this.getParamlist();
  }

  // searchForm = new FormGroup({
  //   f_Year: new FormControl(''),
  // });

  // get f_Year() {
  //   return this.searchForm.get('f_Year');
  // }
  selectYear: any = '';
  selectYear_:any = "";
  financialYears: any = [];
  content_apiresponse: any;
  sucess_message: any;
  status: any;
  getQC_Data: any = [];

  start: number = 0;
  limit: number = 10;
  currentPage: number = 1;
  totalRecords: number = 0;
  RefreshBtn: boolean = false;
  btncontent: any = 'Search';

  ShowTabView: boolean = false;

  getQCData(
    zone: any,
    region: any,
    date: any,
    start: any,
    limit: any,
    currentPage: any
  ) {
    this.btncontent = `<i class="spinner-border spinner-border-sm text-bark" aria-hidden="true"></i>`;
    let param = {
      zone: zone,
      region: region,
      date: date,
      limit: limit,
    };

    this.httpservice
      .getqualitycontrolData(
        param,
        `api/viewIRL_quarterlyLabour_StrengthData?page=${currentPage}`
      )
      .subscribe((response: any) => {
        this.btncontent = 'Search';
        this.content_apiresponse = response;
        let respData = this.content_apiresponse.RESPONSE_DATA;
        let respToken = this.content_apiresponse.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(
          respData,
          environment.apiHashingKey
        ).toString();
        if (respToken == verifyToken) {
          let response: any = Buffer.from(respData, 'base64');
          response = JSON.parse(response);
          // console.log(response);
          if (response.status == 1) {
            this.getQC_Data = response.result.data;
            this.totalRecords = response.result.total;
            // console.log(this.getQC_Data);
          } else {
            Swal.fire({
              icon: 'error',
              text: response.messsage,
            });
          }
        }
      });
  }

  zonelist: any = [];

  getParamlist() {
    let param = {
      selectedYear: '',
    };
    this.httpservice
      .getqualitycontrolData(param, `api/getIRL_quarterlyLabour_StrengthParamData`)
      .subscribe((response: any) => {
        this.content_apiresponse = response;
        let respData = this.content_apiresponse.RESPONSE_DATA;
        let respToken = this.content_apiresponse.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(
          respData,
          environment.apiHashingKey
        ).toString();
        if (respToken == verifyToken) {
          let response: any = Buffer.from(respData, 'base64');
          response = JSON.parse(response);
          if (response.status == 1) {
            this.zonelist = response.zonelist;
          } else {
            Swal.fire({
              icon: 'error',
              text: response.messsage,
            });
          }
        }
      });
  }
 
  pageChanged(page: any, zone: any, region: any, date: any) {
    this.totalRecords = 0;
    this.getQC_Data = [];
    this.currentPage = page;
    this.getQCData(
      zone.value,
      region.value,
      date.value,
      this.start,
      this.limit,
      this.currentPage
    );
  }

  searchQCList(zone: any, region: any, date: any) {
    let selectInput: any = <HTMLElement>window.document.getElementById(zone.id);
    let mohthInput: any = <HTMLElement>window.document.getElementById(region.id);
    if (zone.value !== '') {
      if (region.value !== '') {
        this.selectYear = `${
          mohthInput.options[mohthInput.selectedIndex].text
        }/${selectInput.options[selectInput.selectedIndex].text}`;
      } else {
        this.selectYear = selectInput.options[selectInput.selectedIndex].text;
      }
    } else {
      this.selectYear = '';
    }
    this.RefreshBtn = true;
    this.start = 0;
    this.limit = 10;
    this.currentPage = 1;
    this.totalRecords = 0;
    this.getQCData(
      zone.value,
      region.value,
      date.value,
      this.start,
      this.limit,
      this.currentPage
    );
  }

  regionlist: any = [];
  regionlistNew:any = []
  getRegionList(zone: any, region: any, date: any,type:any){
    let selectInput: any = <HTMLElement>window.document.getElementById(zone.id);
    let mohthInput: any = <HTMLElement>window.document.getElementById(region.id);
    let zonename = "";
    let regionname = "";
    if (zone.value !== '') {
      zonename = selectInput.options[selectInput.selectedIndex].text;
      if (region.value !== '') {
        regionname = mohthInput.options[mohthInput.selectedIndex].text;
        this.selectYear = `${
          mohthInput.options[mohthInput.selectedIndex].text
        }/${selectInput.options[selectInput.selectedIndex].text}`;
      } else {
        this.selectYear = selectInput.options[selectInput.selectedIndex].text;
      }
    } else {
      this.selectYear = '';
    }
    if(type==1){
      this.regionlist = [];
      this.RefreshBtn = true;
      this.start = 0;
      this.limit = 10;
      this.currentPage = 1;
      this.totalRecords = 0;
      this.getQCData(zone.value,region.value,date.value,this.start,this.limit,this.currentPage);
    }
    if(type==2){
      this.regionlistNew = [];
    }
    let param = {
      zonename: zone.value,
    };
    this.httpservice
      .getqualitycontrolData(param, `api/getstatisticRegionByZone`)
      .subscribe((response: any) => {
        this.content_apiresponse = response;
        let respData = this.content_apiresponse.RESPONSE_DATA;
        let respToken = this.content_apiresponse.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(
          respData,
          environment.apiHashingKey
        ).toString();
        if (respToken == verifyToken) {
          let response: any = Buffer.from(respData, 'base64');
          response = JSON.parse(response);
          // console.log(response);
          if (response.status == 1) {
            if(type==1){
              this.regionlist = response.regionlist;
            }
            if(type==2){
              this.regionlistNew = response.regionlist;
              this.createChartColumn(zone.value,region.value,date.value,zonename,regionname);
            }
          } else {
            Swal.fire({
              icon: 'error',
              text: response.messsage,
            });
          }
        }
      });
  }





  searchQCChatList(zone: any, region: any, date: any) {
    let selectInput: any = <HTMLElement>window.document.getElementById(zone.id);
    let mohthInput: any = <HTMLElement>window.document.getElementById(region.id);
    let zonename = "";
    let regionname = "";
    if (zone.value !== '') {
      zonename = selectInput.options[selectInput.selectedIndex].text;
      if (region.value !== '') {
        regionname = mohthInput.options[mohthInput.selectedIndex].text;
        this.selectYear_ = `${
          mohthInput.options[mohthInput.selectedIndex].text
        }/${selectInput.options[selectInput.selectedIndex].text}`;
      } else {
        this.selectYear_ = selectInput.options[selectInput.selectedIndex].text;
      }
    } else {
      this.selectYear_ = '';
    }
    this.createChartColumn(zone.value,region.value,date.value,zonename,regionname);
  }

  Toggle(boolean: boolean) {
    this.ShowTabView = boolean;
    $('.Toggle').removeClass('active');
    if(boolean){
      $('#labrchart').addClass('active');
    } else {
      $('#labrtbl').addClass('active');
    }
  }

  public ngAfterViewInit(): void {
    this.createChartColumn('', '', '', '', '');
  }

  // private getRandomNumber(min: number, max: number): number {
  //   return Math.floor(Math.random() * (max - min + 1) + min)
  // }

  createChartColumn(zone: any, region: any, date: any,zonename:any,regionname:any): void {
    let param = {
      zone: zone,
      zonename: zonename,
      region: region,
      regionname: regionname,
      date: date,
    };
// console.log(param);
    this.httpservice
      .getqualitycontrolData(param, `api/getLabourStrengthData`)
      .subscribe((response: any) => {
        let apiresponse: any = response;
        let respData = apiresponse.RESPONSE_DATA;
        let respToken = apiresponse.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(
          respData,
          environment.apiHashingKey
        ).toString();
        if (respToken == verifyToken) {
          let Chatresponse: any = Buffer.from(respData, 'base64');
          Chatresponse = JSON.parse(Chatresponse);
          // console.log(Chatresponse);
          if (Chatresponse.status == 1) {
            const chart = Highcharts.chart(
              'chart-labour' as any,
              {
                title: {
                  text: this.language === 'English' ? 'Quaterly Labour' : 'त्रैमासिक श्रम'
                },
                // subtitle: {
                //     text: 'My custom subtitle'
                // },
                chart: {
                  type: 'column',
                },
                credits: {
                  enabled: false,
                },
                legend: {
                  enabled: false,
                },

                yAxis: {
                  min: 0,
                  title: undefined,
                },
                xAxis: {
                  categories: this.language === 'English' ? ['DLS Capacity','DLS Depots','DLS labour','DPS Capacity','DPS Depots', 'DPS labour','NWNP Capacity','NWNP Depots','NWNP labour'] :[ "डीएलएस क्षमता","डीएलएस डिपो","डीएलएस श्रम","डीपीएस क्षमता","डीपीएस डिपो","डीपीएस श्रम","एनडब्ल्यूएनपी क्षमता", "एनडब्ल्यूएनपी डिपो", "एनडब्ल्यूएनपी श्रम"],
                },
                tooltip: {
                  headerFormat: `<div>Data of : {point.key}</div>`,
                  pointFormat: `<div>{series.name}: {point.y}</div>`,
                  shared: true,
                  useHTML: true,
                },
                plotOptions: {
                  column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                  },
                  // bar: {
                  //   dataLabels: {
                  //     enabled: true,
                  //   },
                  // },
                },
                series: [
                  {
                    name: 'Amount',
                    data: Chatresponse.result,
                    color: '#006637',
                  },
                ],
              } as any
            );
          } else {
            Swal.fire({
              icon: 'error',
              text: Chatresponse.messsage,
            });
          }
        }
      });

  }

  ChangeMonth(val: any): any {
    if (val == '') {
      return '';
    }
    let m: any = parseInt(val);
    if (m <= 9) {
      return `0${m}`;
    }
    return m;
  }

  countDecimals:any = (value:any):any =>{ 
    if ((value % 1) != 0) 
        return value.toString().split(".")[1].length;  
    return 0;
  };
  NumberFormart(num:any):any{
  if(num=='' || num==null){
    return 0;
  }
  if(parseFloat(num) <= 0){
    if(this.countDecimals(num) > 5){
      return parseFloat(num).toFixed(5);
    }
    return num;
  }
  if(parseFloat(num)){
    if(this.countDecimals(num) > 5){
      return parseFloat(num).toFixed(5);
    }
    return num;
  }
  return num;
  }


}
